/**
 * SOVRANOVA — one password rule, used everywhere a password is set.
 * (Pre-beta user-journey audit, 4 Sep 2026.)
 *
 * Sign-up and password-reset must agree: a rule the reset screen enforces but
 * sign-up does not (or the reverse) produces the worst possible outcome — an
 * account you can create but cannot recover into.
 *
 * 8 characters is SOVRANOVA's own floor. Supabase rejects anything under 6
 * server-side regardless; checking here means the person is told before the
 * round trip, in our words rather than the provider's.
 */

export const MIN_PASSWORD_LENGTH = 8;

/**
 * @param {string} password
 * @returns {string|null} a message to show, or null when the password is fine.
 */
export function validatePassword(password) {
  const pw = String(password || '');
  if (!pw) return 'Please choose a password.';
  if (pw.length < MIN_PASSWORD_LENGTH) {
    return `Please use at least ${MIN_PASSWORD_LENGTH} characters.`;
  }
  return null;
}
